module.exports = __webpack_public_path__ + "img/logo_news_ru.a1db2871.svg";